import React from 'react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';

const ServicesPreview = () => {
  const services = [
    { title: 'Doposcuola', desc: 'Supporto educativo quotidiano per bambini e ragazzi', link: '/doposcuola' },
    { title: 'Formazione Digitale', desc: 'Corsi detraibili 100% per professionisti', link: '/formazione' },
    { title: 'Anziani Digitali', desc: 'Alfabetizzazione tecnologica per la terza età', link: '/doposcuola' },
    { title: 'Spazi Sociali', desc: 'Weekend per famiglie ISEE basso', link: '/sede' },
    { title: 'Laboratori', desc: 'Recupero per bambini con difficoltà', link: '/doposcuola' },
    { title: 'Educazione Civica', desc: 'Sostenibilità e cittadinanza attiva', link: '/cittadino' },
  ];

  return (
    <section data-testid="services-preview" className="py-24 bg-[#0A0A0A] relative overflow-hidden">
      <MatrixRain opacity={0.04} speed={0.5} />
      <div className="max-w-6xl mx-auto px-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">I Nostri Servizi</p>
        <div className="flex items-end gap-6 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            Un hub per<br />
            <span className="text-white font-bold">tutti.</span>
          </h2>
          <span className="font-mono font-black text-[#00FF41] text-7xl md:text-9xl leading-none select-none" style={{ textShadow: '0 0 30px rgba(0,255,65,0.4)', letterSpacing: '8px' }}>&lt; /</span>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Link key={i} to={s.link} data-testid={`service-card-${s.title.toLowerCase().replace(/\s/g, '-')}`}
              className="bg-[#111] border border-white/5 p-6 card-hover block group transition-all hover:border-[#00FF41]/30">
              <h3 className="text-lg font-bold mb-2 group-hover:text-[#00FF41] transition-colors">{s.title}</h3>
              <p className="text-white text-sm mb-4 font-bold">{s.desc}</p>
              <span className="text-[#00FF41] text-xs font-mono uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">
                Scopri &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
